module.exports = __webpack_public_path__ + "static/media/connector_mobile.88774c62.svg";